import request from "@/utils/request";

export interface QuestionRecordQuery {
  current?: number;
  size?: number;
  keyword?: string;
  checkerName?: string;
  checkerGender?: string;
  ageStart?: number | null;
  ageEnd?: number | null;
  checkerPhone?: string;
  checkerIdCard?: string;
  questionId?: number | null;
  questionName?: string;
  typeId?: number | null;
  status?: number | null;
  submitStartTime?: string;
  submitEndTime?: string;
}

export function getQuestionRecordList(data: QuestionRecordQuery): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionRecord/list",
    type: "params",
    data
  });
}

export function getQuestionRecordDetail(id: number): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionRecord/get",
    type: "params",
    data: { id }
  });
}

export function deleteQuestionRecord(id: number): Promise<any> {
  return request({
    method: "DELETE",
    url: "manage/questionRecord/delete",
    type: "params",
    data: { id }
  });
}

export function getQuestionRecordStatistics(data: QuestionRecordQuery): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionRecord/statistics",
    type: "params",
    data
  });
}

export function exportQuestionRecordExcel(data: QuestionRecordQuery): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionRecord/exportExcel",
    type: "params",
    responseType: "blob",
    data
  });
}

export function exportQuestionRecordDetailExcel(data: QuestionRecordQuery): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionRecord/exportDetailExcel",
    type: "params",
    responseType: "blob",
    data
  });
}

export function exportQuestionRecordPersonDetailExcel(data: QuestionRecordQuery): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionRecord/exportPersonDetailExcel",
    type: "params",
    responseType: "blob",
    data
  });
}

export function viewQuestionRecordPdf(id: number): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionRecord/viewPdf",
    type: "params",
    responseType: "blob",
    data: { id }
  });
}

export function downloadQuestionRecordPdf(id: number): Promise<any> {
  return request({
    method: "GET",
    url: "manage/questionRecord/downloadPdf",
    type: "params",
    responseType: "blob",
    data: { id }
  });
}
